export const siteContent = {
  brand: {
    name: "Ashish Waghmare",
    logoText: "ashish waghmare",
    phone: "+919920926651",
    email: "ashishfitnesscoaching@gmail.com",
    calendly: "https://calendly.com/ashishfitnesscoaching",
    registrationForm: "https://form.typeform.com/to/OYWZZQeT",
    social: {
      instagram: "https://www.instagram.com/ashishwasfoundlifting/",
      linkedin: "https://www.linkedin.com/in/ashishwaghmare/",
      youtube: "https://www.youtube.com/@ashishwasfoundlifting",
    },
  },
  hero: {
    headline: "Science-Backed Fitness & Nutrition for Students",
    subheadline: "Stronger. Leaner. Healthier. Real results, no gimmicks.",
    cta: "Start Your Transformation",
    ctaHover: "Let's Go!",
    coach: {
      name: "Ashish",
      title: "Student Fitness Coach",
      // Coach photo provided by user
      photo:
        "https://customer-assets.emergentagent.com/job_student-fitness-3/artifacts/oq41ur66_Ashish_Waghmare.jpg",
    },
  },
  about: {
    title: "About Ashish",
    body:
      "Hi, I’m Ashish. I help people simplify fitness and nutrition so they can feel better, move better, and live better. No strict diets, no overcomplicated workouts, just science-backed routines that fit your lifestyle and goals.",
    highlight: "Fitness & Nutrition Coach",
    credentials: [
      
      "Trained under NASM-CNC",
      "Pursuing Nutrition Coaching and Personal Trainining Certifications",
      "Specialized in nutritrion education and hypertrophy programming",
    ],
  },
  coaching: {
    title: "Choose Your Perfect Coaching Plan",
    cta: "Join Now",
    ctaHover: "Start now",
    packages: [
      {
        name: "Starter/Student Plan – Online 1-on-1",
        details: [
          "Personalized workouts & nutrition",
          "Weekly check-ins",
        ],
      },
      {
        name: "Advanced Plan For Busy Professionals",
        details: [
          "Everything above along with weekly Video check-ins",
          "For people with a busier schedule than usual",
          ],
      },
    ],
  },
  testimonials: {
    title: "Proven Results from Real People",
    items: [
      {
        author: "Ayush (Student)",
        text:
          "In less than a month, from June 19th to July 13th, I dropped 5 kgs! I started at 81 kgs and am now down to 76 kgs. The deficit worked magic, and it's all thanks to Ashish's guidance.”",
        highlights: [
          "June 19th to July 13th",
          "dropped 5 kgs",
          "81 kgs",
          "76 kgs",
        ],
      },
      {
        author: "Aryan (Student)",
        text:
          "In just about 10 weeks since May 1st, I've had a massive body recomposition. I started at 68-69 kgs and lost around 4 kgs, but the best part is my strength has increased massively too! Ashish's guidance has been incredible, especially for being so consistent and pushing me, even for free sometimes. This is proof that body recomp done well can make a huge difference. Thanks, boss!”",
        highlights: [
          "I started at 68-69 kgs and lost around 4 kgs",
        ],
      },
      {
        author: "Hemant (Student)",
        text:
          "I started my lean bulking phase at 50 kgs and, in just 2.5 months, I'm up to 52.8 kgs! That's a solid 2.8 kg gain in total, with no excess fat. The results are amazing—I've seen major improvements in strength in the gym, too. The real benefit of Ashish's coaching is the accountability; he pushes me to eat enough and provides strategic advice, like when to increase my calories, which is why I haven't hit a plateau. The guidance has definitely helped!”",
        highlights: [
          "The results are amazing—I've seen major improvements in strength",
        ],
      },
      {
        author: "Aayaan (College Studnet)",
        text:
          "Over the past few months, Ashish has genuinely changed the way I approach fitness. Between the customized workouts and constant motivation, I’ve been able to lose weight in a way that feels sustainable.It’s not just a temporary fix; it’s a lifestyle change. If this is the level of dedication provided now, I can confidently say that any future clients are in amazing hands!”",
        highlights: [
          "I can confidently say that any future clients are in amazing hands!",
        ],
      },
      {
        author: "Shreeya (Working Professional)",
        text:
          "Since starting with Ashish in mid-May, and over the course of about 2.5 to 3 months, I've achieved a significant milestone! Despite being a working professional and having to battle frustrating weight fluctuations, I've successfully dropped 5 kgs in total. I started at 74.5 kgs and am now at 69.5 kgs. Ashish's consistent guidance has been key to overcoming those hurdles and achieving this great result. Big Ws, indeed!”",
        highlights: [
          "I started at 74.5 kgs and am now at 69.5 kgs",
        ],
      },
      {
        author: "Areeb (Working Professional & Exam Prep)",
        text:
          "I needed a weight loss plan that was realistic and sustainable, especially while juggling work and preparing for an exam. Ashish delivered! In just 2 months, I successfully went from 79 kgs to 75 kgs—a solid 4 kg drop. The best part is that I achieved this without losing any strength. Ashish's approach is truly peak; he proved you can lose weight effectively even during stressful periods.”",
        highlights: [
          "I successfully went from 79 kgs to 75 kgs—a solid 4 kg drop",
        ],
      },
      {
        author: "Nirzar (16-year-old student)",
        text:
          "I upgraded my chest fly to 30 kg and hit 40 kg barbell bench press for 5 reps today. Never thought I’d be lifting like this at 16. The progress has been steady and feels solid every week.”",
        highlights: [
          "Never thought I’d be lifting like this at 16",
        ],
      },
      {
        author: "Aditya (Student)",
        text:
          "When I started, I could barely lift properly on incline bench. Now I’m hitting 17.5 kg dumbbells for 6 reps and doing cable flies with 20 kg each side. Never thought I’d reach this level so soon. Three months of consistency — that’s all it took to feel stronger, more confident, and see real progress.”",
        highlights: [
          "17.5 kg dumbbells",
          "6 reps",
          "cable flies with 20 kg",
          "Three months of consistency",
        ],
      },
    ],
  },
  faq: {
    title: "Got Questions? We've Got Answers",
    items: [
      { q: "How can I start coaching with you?", a: "Just click the WhatsApp button or fill out the form below. I’ll reply personally, and we’ll choose the right plan for you." },
      { q: "Do I need to pay in advance?", a: "Yes, payment is made before your plan begins. Once confirmed, your personalized plan starts within 24 hours." },
      { q: "How will I receive my workout and diet plan?", a: "You’ll get everything digitally through WhatsApp or Google Drive—easy to access on your phone anytime." },
      { q: "What if I’m a beginner or have never gone to the gym?", a: "No problem. Every plan starts from your current level. You’ll get clear instructions and simple routines to build consistency first." },
      { q: "Can I change my plan later?", a: "Yes, you can upgrade or switch plans anytime. Just text me and we’ll adjust it based on your progress and schedule." },
      { q: "Do you offer nutrition guidance too?", a: "Yes, all plans include nutrition support—customized based on your college lifestyle, preferences, and budget." },
      { q: "What’s the best way to contact you?", a: "WhatsApp is fastest. You can also reach me through the contact form on the site for coaching or other questions." },
    ],
  },
  contact: {
    title: "Let’s Get Started",
    body:
      "Message me on WhatsApp or fill the form below. I’ll get back to you fast.",
    cta1: "WhatsApp Me",
    cta2: "Send Message",
  },
};

export function getWhatsAppLink(message = "Hi Ashish, I'd like to start my plan.") {
  const phone = siteContent.brand.phone.replace(/[^\d]/g, "");
  const text = encodeURIComponent(message);
  return `https://wa.me/${phone}?text=${text}`;
}
